import type { NodeCategory } from '@bandos/shared'
import type { ReactFlowNodeData } from '../types/mindmap-components'

/**
 * Options for creating node data
 */
export interface CreateNodeDataOptions {
  nodeId: string
  category: NodeCategory
  mindmapId?: string
  initialData?: Partial<ReactFlowNodeData>
}

/**
 * Create ReactFlowNodeData object with basic properties.
 * Callbacks are now accessed via NodeActionsContext instead of being passed through node.data.
 */
export function createNodeData({
  nodeId,
  category,
  mindmapId,
  initialData = {},
}: CreateNodeDataOptions): ReactFlowNodeData {
  return {
    id: nodeId,
    label: initialData.label ?? '',
    category,
    mindmapId,
    toolbarVisible: false,
    ...initialData, // This spread preserves stakeholderRating and all other fields
  }
}
